<div mat-dialog-title fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="section-title">Comentários do paciente</h2>
    <button mat-icon-button mat-dialog-close>
        <mat-icon>close</mat-icon>
    </button>
</div>
<mat-dialog-content class="mat-typography flex flex-col space-y-4 h-full" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <span *ngIf="patientName">
        <b> Paciente:</b> <a [href]="'/patient/' + patientId"> {{ patientName }}</a></span
    >
    <div class="flex flex-col space-y-4">
        <span>Atividade: {{ title }}</span>
        <span>Comentários: {{ description }}</span>
    </div>
    <mat-divider></mat-divider>
    <div class="flex flex-col space-y-4">
        <span>Comentários do Paciente:</span>
        <span>{{ comments }}</span>
    </div>
</mat-dialog-content>
